import React from "react";
import CiroDropDown from "../../../../../shared/CiroDropdown";
import CiroInternalCountries from "../../../../../../constants/CiroInternalFilters/CiroInternalCountries";
import { IPowersearchFieldValueProps } from "./PowersearchFieldValue";

export const PowersearchCountryValueEditor: React.FC<
  IPowersearchFieldValueProps
> = ({ value, handleOnChange, disabled, errorMessage }) => {
  return (
    <CiroDropDown
      isMulti={true}
      isDisabled={disabled}
      value={value}
      onChange={(newValue) => {
        handleOnChange(newValue);
      }}
      menuPlacement="top"
      menuPortalTarget={document.body}
      options={CiroInternalCountries.map((country) => {
        return {
          value: country.id,
          label: country.label,
        };
      })}
      error={errorMessage}
    />
  );
};

export default PowersearchCountryValueEditor;
